export default "__VITE_ASSET__f81fedae__"